// extracted by mini-css-extract-plugin
export default {"myCommonOverlay":"rN4LgfuJEeoFFX_oZBpg","myCommonModal":"Vwq9XoCHKgRomkg0eaQT","orderSummaryModal":"EziPSHHKec8V7KTHcnpG"};